import { axiosInstance } from "./apiConfig"

export const apiUpdateBooking = async ({
    storeId,
    bookingCode,
    VisitDate,
    VisitTime,
    SpecialRequests,
    PromotionId,
    PartySize,
    name,
    surname,
    mobilePhone,
    email,
    mobilePhoneCountryCode,
    receiveEmailMarketing = false,
    emailMarketingOptInText = '',
}) => {
    const response = await axiosInstance.post(
        `/thirdparty/resdiary/store/${storeId}/booking/${bookingCode}`,
        `VisitDate=${VisitDate}&VisitTime=${VisitTime}&PartySize=${PartySize}` +
        `&Customer[FirstName]=${name}&Customer[Surname]=${surname}` +
        `&Customer[MobileCountryCode]=${mobilePhoneCountryCode}` +
        `&Customer[Mobile]=${mobilePhone}` +
        `&SpecialRequests=${SpecialRequests}` +
        `&PromotionId=${PromotionId || null}` +
        `&Customer[Email]=${email}` +
        `&IsLeaveTimeConfirmed=false` +
        `&Customer[ReceiveEmailMarketing]=${receiveEmailMarketing}` +
        `&Customer[ReceiveRestaurantEmailMarketing]=${receiveEmailMarketing}` +
        `&Customer[GroupEmailMarketingOptInText]=${emailMarketingOptInText}` +
        `&Customer[RestaurantEmailMarketingOptInText]=${emailMarketingOptInText}`,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
    );
    return response.data;
}


// WEBPACK FOOTER //
// ./src/api/apiUpdateBooking.js